// Exact membership diff for the viewport-culled vineyard layer.
//
// Replaces the old length/first-id/last-id equality heuristic, which had
// false positives (equal counts entering and leaving with stable endpoints
// read as "unchanged" and left stale polygons mounted — and an off-screen
// selection appended at the end neutralized the last-id check entirely).
//
// Given the previously mounted id set and the newly culled features, returns
// exactly what to mount and unmount so the caller can diff-apply instead of
// rebuilding the whole layer.

export function diffCulled(prevIds, features) {
  const nextIds = new Set();
  const added = [];
  for (const f of features) {
    const id = f.properties?.id;
    if (!id || nextIds.has(id)) continue;
    nextIds.add(id);
    if (!prevIds?.has(id)) added.push(f);
  }
  const removed = [];
  if (prevIds) {
    for (const id of prevIds) {
      if (!nextIds.has(id)) removed.push(id);
    }
  }
  return { nextIds, added, removed, changed: added.length > 0 || removed.length > 0 };
}
